import { Icon } from "@iconify/react";
import { Box, Button, IconButton, Typography, Rating, Link } from "@mui/material";
import React, { useState } from "react";
import AmazonAvailable from "../../products/available_at_amazon_US_EN_logo_stacked_RGB_SQUID.png"

let affiliateLinks = {
  "48500205853": {
    link: "https://amzn.to/3XQEEJo",
    price: "2.69",
    estimatedDelivery: 1,
  },
  "818253779570": {
    link: "https://amzn.to/4lFqDsj",
    price: "58.55",
    estimatedDelivery: 9,
  },
  "691035387039": {
    link: "https://amzn.to/3E2Jqga",
    price: "15.48",
    estimatedDelivery: 1,
  },
  "696545186097": {
    link: "https://amzn.to/44hkY5b",
    price: "13.49",
    estimatedDelivery: 1,
  },
  "048500205716": {
    link: "https://amzn.to/444rGvx",
    price: "3.33",
    estimatedDelivery: 1,
  },
  "3378872129776": {
    link: "https://amzn.to/3XCgrq5",
    price: "15.96",
    estimatedDelivery: 9,
  },
  "016000124998": {
    link: "https://amzn.to/3FHnhnS",
    price: "3.66",
    estimatedDelivery: 5,
  },
};

const OnlineStores = ({ product }) => {
 
  const [open, setOpen] = useState(false);
  
  const upcData = affiliateLinks[String(product.upc)];
  const stores = upcData
    ? [
        {
          id: "amazon",
          name: "Amazon",
          image: AmazonAvailable,
          price: `$${upcData.price}`,
          link: upcData.link,
          estimatedDelivery: `${upcData.estimatedDelivery} day${upcData.estimatedDelivery > 1 ? "s" : ""}`,
        },

      ]
    : [];

  const [selectedStore, setSelectedStore] = useState(stores[0] || null);

  const handleOpen = () => {
    setOpen(true);
    console.log("product image: " + product.image);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      {upcData && (
        <IconButton
          onClick={handleOpen}
          sx={{
            width: "103px",
            height: "53px",
            borderRadius: "30px",
            background: "#E8E8E8",
            gap: 1,
            "&:hover": {
              background: "#E8E8E8",
              opacity: 1,
            },
          }}
        >
          <Icon icon={"mi:shopping-cart-add"} style={{ color: "#205375" }} />
          <Typography variant="h6" sx={{ color: "#205375" }}>
            Buy
          </Typography>
        </IconButton>
      )}

      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              width: "900px",
              height: "80vh",
              background: "#E6F5FA",              
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              padding: "16px",
              overflow: "hidden",
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
             
            }}
          >
            <div style={{ display: "flex", flex: 1, height: "100%" }}>
              {/* left side*/}
              <Box
                sx={{
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Typography variant="h6" sx={{ marginBottom: "16px", color: "#0E2B5D" }}>
                  Online Stores
                </Typography>

                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    paddingRight: "16px",
                    paddingBottom: "24px",
                    marginBottom: "10px",
                  }}
                >
                  {stores.length > 0 ? (
                    stores.map((store, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "white",
                          borderRadius: "12px",
                          padding: "12px 16px",
                          border:
                            selectedStore?.id === store.id
                              ? "2px solid #154490"
                              : "2px solid #f5f5f5",
                          marginBottom: "12px",
                          cursor: "pointer",
                          "&:hover": {
                            border: "2px solid #154490",
                          },
                        }}
                        onClick={() => setSelectedStore(store)}
                      >
                        {/* Left section: Logo + Info */}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={store.image}
                            alt={store.name}
                            style={{
                              width: "32px",
                              height: "32px",
                              objectFit: "contain",
                              marginRight: "12px",
                            }}
                          />
                          <Box>
                            <Typography
                              sx={{ fontSize: "12px", fontWeight: 500, color: "#0E2B5D" }}
                            >
                              Price: {store.price}
                            </Typography>
                            <Typography
                              sx={{ fontSize: "12px", color: "#0E2B5D", marginTop: "2px" }}
                            >
                              Estimated Delivery: {store.estimatedDelivery}
                            </Typography>
                          </Box>
                        </Box>
                        <IconButton
                          href={selectedStore.link}
                          sx={{
                            width: "83px",
                            height: "35px",
                            borderRadius: "30px",
                            border: "2px solid #E5E5E5",
                            gap: 1,
                          }}
                        >
                          <Icon icon={"mi:shopping-cart-add"} style={{ color: "#205375" }} />
                          <Typography variant="h6" sx={{ color: "#205375", fontSize: "14px" }}>
                            Buy
                          </Typography>
                        </IconButton>
                        
                      </Box>
                    ))
                  ) : (
                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                      No stores available.
                    </Typography>
                  )}

                </Box>

                <Button
                  onClick={handleClose}
                  style={{
                    backgroundColor: "#154490",
                    color: "white",
                    marginBottom: "24px", 
                    paddingBottom: "8px",
                    width: "55%",
                    alignSelf: "center",
                  }}
                >
                  Close
                </Button>
              </Box>

              {/* right side */}
              <Box
                  sx={{
                    width: "60%",
                    maxWidth: "500px",
                    height: "100%",
                    backgroundColor: "white",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                {/* Product Image */}
                <Box
                  sx={{
                    width: "100%",
                    height: "175px",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={product.image
                      ? product.image
                      : `https://placehold.co/800x400?text=${product.name}`}
                    alt={`${product.name}`}
                    style={{
                      maxWidth: "30vh",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                    
                  
                  { product.Classifications && product.Classifications.length > 0 && product.Classifications[0] !== "error" && (<Typography variant="body2" color="primary" fontWeight={500}>
                    {product.Classifications[0]}
                  
                  </Typography>
                  )}
                  {/* Name */}
                  <Typography variant="h6" fontWeight={600} fontSize={24}>
                    {product.name}
                  </Typography>
                    
                  {/* Rating */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Rating value={4.5} precision={0.5} readOnly />
                    <Typography variant="body2" fontWeight={500}>
                      4.5
                    </Typography>
                  </Box>
                    
                  {/* Price & Delivery */}
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Price: {selectedStore.price}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Estimated Delivery: {selectedStore.estimatedDelivery}
                    </Typography>
                  </Box>
                    
                  {/* Description */}
                  <Box sx={{overflowY: "scroll", height: '150px'}}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, marginBottom: "4px" }}
                    >
                      Description
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {product.description}
                    </Typography>
                  </Box>
                    
                  <IconButton
                    component="a"
                    href={selectedStore.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      backgroundColor: "#154490",
                      color: "white",
                      textTransform: "none",
                      fontWeight: "bold",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      "&:hover": {
                        backgroundColor: "#002B66",
                        opacity: 1,
                      },
                    }}
                  >
                    <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
                      View at {selectedStore.name}
                    </Typography>
                    <Icon icon="tabler:external-link" style={{ fontSize: "20px" }} />
                  </IconButton>
                </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OnlineStores;
